import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftAutocompleteResponse } from '@/repositories/generated';

// 名称・IDは取引履歴一覧モック（src/mocks/api/transaction/transaction.ts）と整合させている
const response: GiftAutocompleteResponse[] = [
  {
    id: '1',
    name: '熊本市デジタル商品券',
  },
  {
    id: '4',
    name: '自由枠事業A',
  },
  {
    id: '7',
    name: 'ABI用商品券事業01',
  },
];

export const autocompleteGiftBusiness = http.get(
  createMockEndpoint('/autocomplete/gift_business'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
